// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixData from 'wix-data';

$w.onReady( () => {
  $w("#dataset1").onReady( () => {
    $w("#repeater4").forEachItem(($w, itemData, index) =>
    {
      $w("#text62").html =  "<span style='font-family:dinneuzeitgroteskltw01-_812426,sans-serif; font-size:18px;'>" + $w("#dataset1").getCurrentItem().name + "&nbsp;&nbsp;</span>" + "<span style='font-family:open sans condensed,sans-serif; font-size:15px;'>" + "-&nbsp;&nbsp;" + $w("#dataset1").getCurrentItem().note + "</span>";
      $w("#text64").text =(index+1).toString() +".";
      if (index % 2 ===0) 
      {
        $w("#box4").style.backgroundColor = "#B9EBEB";
      }
      else
      {
        $w("#box4").style.backgroundColor = "#76C8D7";

      }
	  
      
      
    });
    
  } );

} );